import React, { useEffect, useState } from 'react';
import { DateInput } from 'semantic-ui-calendar-react';
import { Checkbox, Dropdown, Input } from 'semantic-ui-react';
import { useDebounce } from 'use-lodash-debounce';
import { useAuth } from '~/routes/components/AuthProvider';
import { deserializeFilters } from '.';
import { useHash } from '~/components/useHash';

interface Props {
  milkDeliveryOptions: any
  dataFiltered: any
  onChangeDataFiltered: (data: any) => void
  checkedFilters: any[]
}

const Filters: React.FC<Props> = (props) => {
  const { systemData: { languages, logged: { languageId } } } = useAuth()
  const languageLocal = languages.find(language => language.id === languageId)

  const [hash] = useHash()
  const [inputValues, setInputValues] = useState(() => {
    const filtersFromHash = deserializeFilters(hash, {
      vehicleNumber: '',
      tourNumber: '',
      driverNumber: '',
      totalAmountFrom: '',
      totalAmountTo: '',
      sampleBottleNumber: ''
    });
    return filtersFromHash
  })
  const debounceInputValues = useDebounce(inputValues, 300)

  const {
    milkDeliveryOptions,
    dataFiltered,
    onChangeDataFiltered,
    checkedFilters
  } = props

  useEffect(() => {
    onChangeDataFiltered({
      ...dataFiltered,
      ...debounceInputValues
    })
  }, [debounceInputValues])

  function renderDropdownFilter(filter) {
    const { key, placeholder, optionKey } = filter
    return <Dropdown
      key={key}
      selectOnBlur={false}
      placeholder={placeholder}
      selection
      value={dataFiltered[key]}
      clearable
      onChange={(e, data) => onChangeDataFiltered({
        ...dataFiltered,
        [key]: data.value
      })}
      options={milkDeliveryOptions[optionKey].map(option => ({ text: option, value: option }))}
    />
  }

  const handleKeyPress = (event) => {
    event.preventDefault();
  }

  function renderDateInput(filter) {
    return <DateInput
      name='date'
      autoComplete='off'
      placeholder={filter.placeholder}
      closable
      clearIcon={'close'}
      clearable
      localization={languageLocal.code}
      onKeyPress={handleKeyPress}
      closeOnMouseLeave={false}
      dateFormat={'DD.MM.YYYY'}
      className={'datePicker'}
      minDate={filter.key === 'dateTo' ? dataFiltered.dateFrom : ''}
      value={dataFiltered[filter.key]}
      iconPosition='left'
      onChange={(e, data) => onChangeDataFiltered({
        ...dataFiltered,
        [filter.key]: data.value
      })}
    />
  }

  function renderInputFilter(filter) {
    if (filter?.type === 'date') {
      return renderDateInput(filter)
    }

    return <Input
      icon={{ name: 'sort numeric down', circular: true, link: true }}
      placeholder={filter.placeholder}
      value={inputValues[filter.key]}
      type='number'
      onKeyPress={(event) => {
        if (!filter.decimalScale && !/[0-9]/.test(event.key)) {
          event.preventDefault();
        }
      }}
      onChange={(e, data) => setInputValues({
        ...inputValues,
        [filter.key]: data.value
      })}
    />
  }

  return <>
    {milkDeliveryOptions && checkedFilters.map(filter => {
      if (filter.label) {
        return <Checkbox
          key={filter.key}
          checked={Boolean(dataFiltered[filter.key])}
          label={filter.label}
          onChange={(e, data) => onChangeDataFiltered({
            ...dataFiltered,
            [filter.key]: data.checked ? 1 : 0
          })}
        />
      }
      return filter.optionsKey ? renderDropdownFilter(filter) : renderInputFilter(filter)
    })}
  </>
}
export default Filters